import * as S from 'components/SidebarContentPreview/SidebarContentPreviewItem/SidebarContentPreviewItemStyles';
import Link from 'components/Globals/Base/Link';
import { Video } from 'interfaces/content/Media';
import VideoPreview from 'components/VideoPreview';

interface SidebarContentPreviewVideoProps {
  entry: Video;
  contentPlacementCD: string;
}

const SidebarContentPreviewVideo = ({ entry, contentPlacementCD }: SidebarContentPreviewVideoProps) => {
  const videoLink = `https://fortune.com/videos/watch/${entry.videoId}`;

  const trackingData = {
    contentPlacementCD,
    contentTagsCD: entry.categories,
    eventCategory: 'navigation',
    eventLabel: entry.name,
  };

  const wellCategory = entry.categories.find((category) => category.parentName === 'Fortune_Well')?.label;
  const section = wellCategory || entry.section.label;

  return (
    <S.Card>
      <S.Content>
        <S.Left>
          <Link
            href={videoLink}
            trackingData={{ ...trackingData, eventAction: 'category click' }}
            target='_blank'
            rel='noopener noreferrer'
            className='section'
            type='red'
          >
            {section}
          </Link>
          <Link
            href={videoLink}
            trackingData={{ ...trackingData, eventAction: 'title click' }}
            target='_blank'
            rel='noopener noreferrer'
            className='title-link'
            type='primary'
          >
            {entry.name}
          </Link>
        </S.Left>
        <S.Right>
          <Link
            href={videoLink}
            trackingData={{ ...trackingData, eventAction: 'thumbnail click' }}
            target='_blank'
            rel='noopener noreferrer'
          >
            <VideoPreview video={entry} />
          </Link>
        </S.Right>
      </S.Content>
    </S.Card>
  );
};

export default SidebarContentPreviewVideo;
